import React, { useState } from "react";
import useSettings from "stores/settings";
import Modal from "react-awesome-modal";
import { FormatDate } from "components/FormatDate";
import TextField from "@material-ui/core/TextField";
import { BasicAlert } from "components/Alert";
import cuid from "cuid";
import Costinput from "./Costinput";
import { projectFirestore } from "components/ProjectFirestore";

const Charge = () => {
  // const [tab, setTab] = useState("이용권");
  // const tabClick = (value) => {
  //   setTab(value);
  // };
  return (
    <div>
      {/* <div className="w-full mb-3">
        <ul className="flex items-center m-0">
          <li className="nav-item">
            <a className={`nav-link category-simple-menu ${tab === "이용권" ? "active" : ""}`} onClick={() => tabClick("이용권")}>
              이용권
            </a>
          </li>
          <li className="category-simple-menu-line">|</li>
          <li className="nav-item">
            <a className={`nav-link category-simple-menu ${tab === "일반 충전" ? "active" : ""}`} onClick={() => tabClick("일반 충전")}>
              일반 충전
            </a>
          </li>
        </ul>
      </div> */}
      <ChargeContent />
    </div>
  );
};

const ChargeContent = () => {
  const settings = useSettings();
  // 결제 금액 입력 및 확인 모달
  const [modalVisible, setModalVisible] = useState(false);
  const [modalVisible2, setModalVisible2] = useState(false);

  // 충전 금액
  const [chargeCredit, setChargeCredit] = useState(0);
  const [chargePrice, setChargePrice] = useState(0);

  const handleInputChargeModalOpen = () => {
    setChargeCredit(10);
    setChargePrice(100);
    setModalVisible(true);
  };

  const handleFixChargeModalOpen = (credit, price) => {
    setChargeCredit(credit);
    setChargePrice(price);
    setModalVisible2(true);
  };

  const closeModal = () => {
    setModalVisible(false);
  };

  const handleModalOkButton = async () => {
    setChargePrice(Number(chargeCredit) * 10);
    if (chargeCredit < 10) {
      const text = "10Credit부터 충전이 가능합니다.";
      BasicAlert(text);
      return;
    }
    setModalVisible(false);
    const price = Number(chargeCredit) * 10;

    const buyerEmail = settings.email;
    const buyerName = settings.name;

    iamPort(price, buyerEmail, buyerName);
  };

  const handleModalOkButton2 = () => {
    setModalVisible2(false);

    const buyerEmail = settings.email;
    const buyerName = settings.name;

    iamPort(chargePrice, buyerEmail, buyerName);
  };

  /* 아임포트 실행 */
  const iamPort = (amount, buyerEmail, buyerName) => {
    const IMP = window.IMP;
    IMP.init("iamport");
    IMP.request_pay(
      {
        pg: "inicis", // version 1.1.0부터 지원.
        pay_method: "card",
        merchant_uid: cuid(),
        name: "크레딧 충전",
        amount: amount,
        buyer_email: buyerEmail,
        buyer_name: buyerName,
        buyer_tel: "",
      },
      function (rsp) {
        let msg = "";
        if (rsp.success) {
          msg = "결제가 완료되었습니다.\n";
          msg += "고유ID : " + rsp.imp_uid + "\n";
          msg += "상점 거래ID : " + rsp.merchant_uid + "\n";
          msg += "결제 금액 : " + rsp.paid_amount + "\n";
          msg += "카드 승인번호 : " + rsp.apply_num;

          // DB에 저장
          insertPayData(rsp, amount);
        } else {
          msg = "결제에 실패하였습니다.\n";
          msg += rsp.error_msg;
        }
        alert(msg);
      }
    );
  };

  /* 결제 정보 DB에 저장 */
  const insertPayData = async (rsp, amount) => {
    // const id = cuid();
    const createdAt = FormatDate(new Date());
    const credit = chargeCredit;
    const discount = Number(chargeCredit) * 10 - Number(amount);
    const price = Number(chargeCredit) * 10;
    const {
      apply_num,
      bank_name,
      buyer_email,
      buyer_name,
      buyer_tel,
      card_name,
      card_number,
      card_quota,
      currency,
      imp_uid,
      merchant_uid,
      name,
      paid_amount,
      paid_at,
      pay_method,
      pg_provider,
      pg_tid,
      pg_type,
      receipt_url,
      status,
      success,
    } = rsp;
    const field = `id,createdAt,credit,price,discount,applyNum,bankName,buyerEmail,buyerName,buyerTel,cardName,cardNumber,cardQuota,currency,impUid,merchantUid,name,paidAmount,paidAt,payMethod,pgProvider,pgTid,pgType,receiptUrl,status,success`;
    const values = `"${merchant_uid}","${createdAt}",${credit},${price},${discount},"${apply_num}","${bank_name}","${buyer_email}","${buyer_name}","${buyer_tel}","${card_name}","${card_number}","${card_quota}","${currency}","${imp_uid}","${merchant_uid}","${name}",${paid_amount},"${paid_at}","${pay_method}","${pg_provider}","${pg_tid}","${pg_type}","${receipt_url}","${status}",${success}`;

    const requestOptions = {
      headers: {
        "Content-Type": "application/json",
      },
      method: "POST",
      // body: JSON.stringify({ query: "SELECT * FROM appHistory" }),
      body: JSON.stringify({ query: `insert into creditCharge (${field}) values (${values})` }),
    };
    // const jsonData = await fetch(`${process.env.PUBLIC_URL}/api/aisoDatabaseFunction`, requestOptions);
    await fetch(process.env.GOOGLE_CLOUD_DATABASE_CONNECT_API, requestOptions);

    /* firestore credit 정보 저장 */

    /* 사용자 정보 가져오기 */
    const docRef = projectFirestore.collection("users").doc(buyer_email);
    docRef
      .get()
      .then((doc) => {
        if (doc.exists) {
          const beforeCredit = doc.data().credit;
          const afterCredit = beforeCredit + credit;

          const docRefUpdate = projectFirestore.collection("users").doc(buyer_email);
          const value = { credit: afterCredit };

          docRefUpdate.update(value);
        }
      })
      .catch((error) => {
        console.log("Error getting document:", error);
        BasicAlert(error);
      });
  };

  return (
    <div className="xl:px-20 w-full mt-5">
      {/* 직접 입력하여 충전 */}
      <div className="row">
        <div className="col-12 col-sm-4 col-xl-5 pr-3 sm:border-r">
          <p className="font-black text-555 text-lg">크레딧 입력 충전</p>
          <p className="text-888 text-xs">
            원하는 충전 금액만큼 입력하여 충전 <br />
            할인 혜택이 적용되지 않습니다.
          </p>
        </div>
        <div className="col-12 col-sm-8 col-xl-7 md:pl-5">
          <div className="w-full flex items-center justify-between">
            <p>
              <span className="text-555 font-bold text-lg mr-2">1</span>
              <span className="text-555 text-md">Credit</span>
            </p>
            <div className="flex flex-col sm:flex-row items-end sm:items-center justify-end">
              <p className="ml-3">
                <span className="text-555 font-bold text-lg mr-2">10</span>
                <span className="text-555 text-mde">원</span>
              </p>
              <button type="text" className="btn btn-primary px-3 py-2 ml-4" onClick={handleInputChargeModalOpen}>
                결제
              </button>
            </div>
          </div>
        </div>
        {/* 크레딧 입력 모달 */}
        <Modal visible={modalVisible} width="400" height="350" effect="fadeInUp" onClickAway={() => closeModal()}>
          <div className="aiso-modal">
            <div className="aiso-modal-header">
              <button className="btn btn-text-grayPrimary p-3" onClick={() => setModalVisible(false)}>
                <i className="ti-close font-bold"></i>
              </button>
            </div>
            <div className="aiso-modal-body">
              <p className="text-xl font-bold">크레딧 입력 충전</p>
              <Costinput chargeCredit={chargeCredit} setChargeCredit={setChargeCredit} />
            </div>
            <div className="aiso-modal-footer text-center">
              <button type="button" className="btn btn-modal-o w-1/3" onClick={() => handleModalOkButton()}>
                결제 하기
              </button>
            </div>
          </div>
        </Modal>
      </div>
      {/* 요금제로 충전 */}
      <div className="row mt-24">
        <div className="col-12 col-sm-4 col-xl-5 pr-3 sm:border-r">
          <p className="font-black text-555 text-lg">요금제</p>
          <p className="text-888 text-xs">충전 금액이 높을 수록 높은 할인 혜택이 적용됩니다.</p>
        </div>
        <div className="col-12 col-sm-8 col-xl-7 md:pl-5">
          <div className="w-full flex items-center justify-between">
            <p>
              <span className="text-555 font-bold text-lg mr-2">10</span>
              <span className="text-555 text-md">Credit</span>
            </p>
            <div className="flex flex-col sm:flex-row items-end sm:items-center justify-end">
              <p className="ml-3">
                <span className="text-555 font-bold text-lg mr-2">100</span>
                <span className="text-555 text-md">원</span>
              </p>
              <button type="text" className="btn btn-primary px-3 py-2 ml-4" onClick={() => handleFixChargeModalOpen(10, 100)}>
                결제
              </button>
            </div>
          </div>
          <div className="w-full flex items-center justify-between mt-5">
            <p>
              <span className="text-555 font-bold text-lg mr-2">100</span>
              <span className="text-555 text-md">Credit</span>
            </p>
            <div className="flex flex-col sm:flex-row items-end sm:items-center justify-end">
              <p className="line-through text-gray-400 text-md">
                1,000
                <span className="text-md"> 원</span>
              </p>
              <p className="ml-3">
                <span className="text-555 font-bold text-lg mr-2">900</span>
                <span className="text-555 text-mde">원</span>
              </p>
              <button type="text" className="btn btn-primary px-3 py-2 ml-4" onClick={() => handleFixChargeModalOpen(100, 900)}>
                결제
              </button>
            </div>
          </div>
          <div className="w-full flex items-center justify-between mt-5">
            <p>
              <span className="text-555 font-bold text-lg mr-2">1,000</span>
              <span className="text-555 text-md">Credit</span>
            </p>
            <div className="flex flex-col sm:flex-row items-end sm:items-center justify-end">
              <p className="line-through text-gray-400 text-md">
                10,000
                <span className="text-md"> 원</span>
              </p>
              <p className="ml-3">
                <span className="text-555 font-bold text-lg mr-2">9,000</span>
                <span className="text-555 text-mde">원</span>
              </p>
              <button type="text" className="btn btn-primary px-3 py-2 ml-4" onClick={() => handleFixChargeModalOpen(1000, 9000)}>
                결제
              </button>
            </div>
          </div>
        </div>
        {/* 크레딧 입력 모달 */}
        {/* <Modal visible={modalVisible} width="400" height="230" effect="fadeInUp" onClickAway={() => closeModal()}>
          <div className="aiso-modal">
            <div className="aiso-modal-header">
              <button className="btn btn-text-grayPrimary p-3" onClick={() => setModalVisible(false)}>
                <i className="ti-close font-bold"></i>
              </button>
            </div>
            <div className="aiso-modal-body text-center">
              <h3 className="text-xl font-bold text-primary mb-0" id="modal-title">
                결제 하시겠습니까?
              </h3>
              <div className="mt-2">
                <p className="text-xs text-gray-500">결제를 원하시면 확인 버튼을 눌러주세요.</p>
              </div>
            </div>
            <div className="aiso-modal-footer text-center">
              <button type="button" className="btn btn-modal-o w-1/3" onClick={() => handleModalOkButton()}>
                확인
              </button>
            </div>
          </div>
        </Modal> */}
      </div>
      {/* 크레딧 입력 모달 */}
      <Modal visible={modalVisible2} width="400" height="350" effect="fadeInUp" onClickAway={() => setModalVisible2(false)}>
        <div className="aiso-modal">
          <div className="aiso-modal-header">
            <button className="btn btn-text-grayPrimary p-3" onClick={() => setModalVisible2(false)}>
              <i className="ti-close font-bold"></i>
            </button>
          </div>
          <div className="aiso-modal-body">
            <p className="text-xl font-bold">크레딧 충전</p>
            <div className="w-full relative mt-4 {classes.root}">
              <TextField
                label="충전할 크레딧을 확인 해주세요"
                value={chargeCredit}
                disabled
                name="numberformat"
                id="formatted-numberformat-input"
                className="mr-3 w-full"
              />
              <p className="text-xs font-bold text-555 absolute top-8 right-3">Credit</p>
              <div className="flex justify-end items-center px-3 mt-3">
                <p className="text-555 text-xs mr-5">결제 금액</p>
                <p className="text-right">
                  <span className="font-bold text-555 text-xl mr-2">{chargePrice}</span>
                  <span className="text-555 text-xl">원</span>
                </p>
              </div>
            </div>
          </div>
          <div className="aiso-modal-footer text-center">
            <button type="button" className="btn btn-modal-o w-1/3" onClick={() => handleModalOkButton2()}>
              결제 하기
            </button>
          </div>
        </div>
      </Modal>
      {/* <Modal visible={modalVisible2} width="400" height="350" effect="fadeInUp" onClickAway={() => setModalVisible2(false)}>
        <div className="aiso-modal">
          <div className="aiso-modal-header">
            <button className="btn btn-text-grayPrimary p-3" onClick={() => setModalVisible2(false)}>
              <i className="ti-close font-bold"></i>
            </button>
          </div>
          <div className="aiso-modal-body">
            <p className="text-xl font-bold">크레딧 입력 충전</p>
            <div className="w-full relative mt-4 {classes.root}">
              1<p className="text-xs font-bold text-555 absolute top-8 right-3">Credit</p>
              <div className="flex justify-end items-center px-3 mt-3">
                <p className="text-555 text-xs mr-5">결제 금액</p>
                <p className="text-right">
                  <span className="font-bold text-555 text-xl mr-2">0</span>
                  <span className="text-555 text-xl">원</span>
                </p>
              </div>
            </div>
          </div>
          <div className="aiso-modal-footer text-center">
            <button type="button" className="btn btn-modal-o w-1/3" onClick={() => handleModalOkButton2()}>
              결제 하기
            </button>
          </div>
        </div>
      </Modal> */}
    </div>
  );
};

export default Charge;
